import { scroller } from 'react-scroll'

export const handleClick = layoutStore => {
  layoutStore.noScroll = true
  scroller.scrollTo('outfits', {
    duration: 500,
    delay: 100,
    smooth: true,
  })
}
